import { getIconByName } from '../../styles';
import { ICONS } from '../enums/generic.enum';

export class TrueOrFalseCellRenderer {
  init(params) {
    this.content = document.createElement('span');
    this.content.setAttribute('part', 'iconWrapper');

    if (params.value === undefined) {
      return;
    }

    this.content.innerHTML = params.value
      ? getIconByName(ICONS.GREEN_CHECK, null)
      : getIconByName(ICONS.CIRCLED_ERROR, null);
  }

  content: HTMLElement;

  getGui(): HTMLElement {
    return this.content;
  }

  refresh(): boolean {
    return false;
  }
}
